<template>
  <div>
    <div>
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <div class="page-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home/Home' }">主页</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;">产量统计</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 搜索筛选 -->
      <el-form :model="form" class="user-search" label-width="90px" size="small">

        <el-row>
          <el-col :span="6" v-if="'planNum' in colObj2">
            <el-form-item label="工单计划数">
              <el-input-number
              size="small"
              v-model="form.planNum"
              placeholder="请输入工单计划数"
              controls-position="right"
              :min="0"
              clearable
              style="width: 100%;"></el-input-number>

            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'orderStatus' in colObj2">
            <el-form-item label="工单状态">
              <el-select
                  v-model="form.orderStatus"
                  clearable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in orderStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <!--<el-col :span="6" v-if="'producerId' in colObj2">-->
            <!--<el-form-item label="生产人员">-->
              <!--<el-select-->
                  <!--v-model="form.producerId"-->
                  <!--clearable-->
                  <!--placeholder="请选择"-->
                  <!--style="width:100%;"-->
                <!--&gt;-->
                  <!--<el-option-->
                    <!--v-for="item in workAuthList"-->
                    <!--:key="item.value"-->
                    <!--:label="item.label"-->
                    <!--:value="item.value"-->
                  <!--&gt;</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
          <!--</el-col>-->
          <!--<el-col :span="6" v-if="'processCode' in colObj2">-->
            <!--<el-form-item label="工序">-->
              <!--<el-select-->
                <!--v-model="form.processCode"-->
                  <!--clearable-->
                  <!--placeholder="请选择"-->
                  <!--style="width:100%;"-->
                <!--&gt;-->
                  <!--<el-option-->
                    <!--v-for="item in processNameList"-->
                    <!--:key="item.value"-->
                    <!--:label="item.label"-->
                    <!--:value="item.value"-->
                  <!--&gt;</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
          <!--</el-col>-->
          <el-col :span="6" v-if="'productCode' in colObj2">
            <el-form-item label="产品编号">
              <el-input size="small" v-model="form.productCode" placeholder="请输入产品编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'productName' in colObj2">
            <el-form-item label="产品名称">
              <el-input size="small" v-model="form.productName" placeholder="请输入产品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'produceTime' in colObj2">

            <el-form-item label="生产时间">
                <el-date-picker
                  key="0"
                  class="half-width"
                  v-model="form.produceTime"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
          </el-form-item>
          </el-col>

          <el-col :span="4" class="text-align-right">
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
            <!-- <el-popover
              placement="left-start"
              title="列配置"
              width="200"
              trigger="click"
              v-model="popIshow2"
              >
              <PopoverContentNew :colData="colData2" @done="popDone2" v-if="popIshow2" ></PopoverContentNew>
              <el-button slot="reference" icon="el-icon-s-operation" size="small" class="left-default-margin">关键词配置</el-button>
            </el-popover> -->
          </el-col>
        </el-row>


      </el-form>
    </div>

    <div class="white-background">
        <el-row class="tbl-btn">
          <el-col :span="12" class="tbl-btn-left">
            <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportExcelNew">导出</el-button>
          </el-col>
          <!-- <el-col :span="12" style="text-align: right;">
            <el-popover
              placement="left-start"
              title="列配置"
              width="200"
              trigger="click"
              v-model="popIshow"
              >
              <PopoverContentNew :colData="colData" @done="popDone" v-if="popIshow" ></PopoverContentNew>
              <el-button slot="reference" icon="el-icon-s-operation" size="small" class="left-default-margin">列配置</el-button>
            </el-popover>
          </el-col> -->
        </el-row>
        <el-table
          ref="tableData"
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 100%;"
          row-key="_id"
          @selection-change="handleTblSelectionChange"
          id="tableData"
        >
          <el-table-column align="left" type="selection" :reserve-selection="true" width="60" fixed="left"></el-table-column>
          <el-table-column align="left" type="index" width="50" label="序号" fixed="left"></el-table-column>

          <el-table-column label="产品编号"  v-if="'productCode' in colObj" fixed="left">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.productCode" placement="top">
                <span class="txt-overflow">{{scope.row.productCode}}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="产品名称" v-if="'productName' in colObj" fixed="left">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.productName" placement="top">
                <span class="txt-overflow">{{scope.row.productName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" width="90" fixed="left"></el-table-column>
          <!-- <el-table-column prop="produceTime" label="生产时间" width="150" v-if="'produceTime' in colObj"></el-table-column> -->
          <el-table-column prop="specs" label="产品规格"  fixed="left"></el-table-column>
          <el-table-column prop="totalNum" label="合计"  v-if="'totalNum' in colObj" fixed="left"></el-table-column>
          <el-table-column v-for="item in setList" :key="item" :prop="item" :label="item"></el-table-column>



        </el-table>
        <!-- 分页组件 -->
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination> -->
      </div>
      </div>

  </div>
</template>
<script>

import {productCountReport,queryAllUserList} from '@/api/business';
import { processGetAll} from '@/api/basicData';
import Pagination from "@/components/Pagination";
import moment from 'moment';
import PopoverContentNew from '@/components/PopoverContentNew'
import {exportDataToExcel,transfer} from '@/utils/util';
import { head } from 'shelljs';



export default {
  name: "FinishedProduction",
  components:{
      Pagination,
      PopoverContentNew
  },
  data() {
    return {
      conditionOptions: [
        {
          value: "between",
          label: "选择范围"
        },
        {
          value: "lt",
          label: "小于"
        },
        {
          value: "lte",
          label: "小于等于"
        },
        {
          value: "eq",
          label: "等于"
        },
        {
          value: "gt",
          label: "大于"
        },
        {
          value: "gte",
          label: "大于等于"
        }
      ],
      dynamicDate: [{
        value: '0',
        label: '今天',
      }, {
        value: '1',
        label: '昨天'
      }, {
        value: '2',
        label: '本周'
      }, {
        value: '3',
        label: '上周'
      }, {
        value: '4',
        label: '本月'
      }, {
        value: '5',
        label: '上月'
      }, {
        value: '6',
        label: '近三月'
      }, {
        value: '7',
        label: '自定义'
      }],
      dateOneOptions:[{
        value: '过去',
        label: '过去'
      }, {
        value: '未来',
        label: '未来'
      }],
      dateTwoOptions:[{
        value: '日',
        label: '日'
      }, {
        value: '周',
        label: '周'
      }, {
        value: '月',
        label: '月'
      }, {
        value: '季度',
        label: '季度'
      }, {
        value: '年',
        label: '年'
      }],
      form: {
      },
      orderStatusList: [
      {
          label: "未开始",
          value: "未开始"
        },
        {
          label: "执行中",
          value: "执行中"
        },
        {
          label: "已结束",
          value: "已结束"
        },
        {
          label: "已取消",
          value: "已取消"
        }
      ],
      isFold: true,
      listData: [],
      loading: false,
      isBatchPrint: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      createProductPanVisible:false,
      isMain:true,

      userData:{},
      editRow:{},
      mode:'',
      sourceList:[{
        label:'自制',
        value:'0'
      },{
        label:'外购',
        value:'1'
      },{
        label:'委外',
        value:'2'
      }],
      setList:[],
      popIshow:false,//控制popover显隐

      colData:[],
      colDataRes:{
        // "工单计划数":"planNum",
        // "工单状态":"orderStatus",
        // "生产人员":"producerId",
        "工序":"processCode",
        "产品名称":"productName",
        "产品编号":"productCode",
        "生产时间":"produceTime",
        // "产品规格":"specs",
        // "单位":"unit",
        "合计":"totalNum"
      },
      colObj:{},
      popIshow2:false,
      colData2:[],
      colObj2:{},
      processNameList: [],
      workAuthList: [],
      tblSelectionList:[]

    };
  },
  created() {
    for(let key in this.colDataRes){
      this.colData.push({label:this.colDataRes[key],value:key,istrue:true});
      this.colObj[this.colDataRes[key]] = key;
      this.colData2.push({label:this.colDataRes[key],value:key,istrue:true});
      this.colObj2[this.colDataRes[key]] = key;
    }
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
      this.init();
      this.initDict();
    }
  },
  methods: {
    returnRowkey(row){
      return row['_id'] + row[''];
    },
    dynamicUpdateValueChange:function(){
      if(this.form.dynamicUpdateValue == '7'){
        this.$set(this.form,'dateUpdateInput','1')
      }else{
        delete this.form.dateUpdateInput
      }
    },
    dateInputUpdateBlur:function(){
      if(this.form.dateUpdateInput == undefined){
        this.$set(this.form,'dateUpdateInput','1')
      }
    },
    dateInputCreateBlur:function(){
      if(this.form.dateCreateInput == undefined){
        this.$set(this.form,'dateCreateInput','1')
      }
    },
    dynamicUpdateValueChange:function(){
      if(this.form.dynamicUpdateValue == '7'){
        this.$set(this.form,'dateUpdateInput','1')
      }else{
        delete this.form.dateUpdateInput
      }
    },
    updateApprovalChange: function() {
      this.$set(this.form, "approvalValue", "");
    },
    async initDict(){
      // let res = await processGetAll(this.userData.factoryId);
      // if(res['code'] == 200){
      //   this.processNameList = res.data.map(function(item){
      //     return {
      //       label:item.processName,
      //       value:item.processCode
      //     }
      //   });
      // }
      let res = await queryAllUserList(this.userData.factoryId);
      if(res['code'] == 200){
        this.workAuthList = res.data.map(function(item){
          return {
            label:item.name + '(' + item.account + ')',
            value:item._id,
          }
        });
      }
    },
    popDone:function(options){
      var _this = this
      this.popIshow = false
      if(options.type == 'save'){
        this.colData = JSON.parse(JSON.stringify(options.data));
        this.colObj = {};
        for(let i = 0;i<this.colData.length;i++){
          if(this.colData[i].istrue){
            this.colObj[this.colData[i].label] = this.colObj[this.colData[i].value];
          }
        }
        this.init();
      }
    },
    popDone2:function(options){
      var _this = this
      this.popIshow2 = false
      if(options.type == 'save'){
        this.colData2 = JSON.parse(JSON.stringify(options.data));
        this.colObj2 = {};
        var _form = {};
        for(let i = 0;i<this.colData2.length;i++){
          if(this.colData2[i].istrue){
            this.colObj2[this.colData[i].label] = this.colObj2[this.colData2[i].value];
            _form[this.colData[i].label] = this.form[this.colData[i].label]
          }
        }
        this.form = JSON.parse(JSON.stringify(_form));
        this.init();
      }
    },
    goBack(){
      this.$router.go(-1);
    },
    init(){
      this.search();

    },
    fold() {
      this.isFold = !this.isFold;
    },
    search() {
      this.loading = true
      var data = {
        condition: {},
        // currentPage: this.pageparm.currentPage,
        // pageSize: this.pageparm.pageSize,
      }
      for(var key in this.form){

        if(this.form[key] && this.form[key] != null && (this.form[key].length > 0 || this.form[key].toString() != '')){
            if(key == "produceTime"){
              data['condition'][key] = {
                begin:this.form.produceTime[0].substring(0,10) + " 00:00:00",
                end:this.form.produceTime[1].substring(0,10) + " 23:59:59",
                type:"between" ,
                data:'date'
              }
            }else if(key != 'aprovalCondition'){

              data['condition'][key] = this.form[key];
            }
        }else{
          // if(key == "produceTime"){
          //   data['condition'][key] = {
          //     begin:moment().format("YYYY-MM-DD HH:mm:ss").substring(0,8) + '01' + " 00:00:00",
          //     end:moment().format("YYYY-MM-DD HH:mm:ss").substring(0,10) + " 23:59:59",
          //     type:"between" ,
          //     data:'date'
          //   }
          // }
        }
      }
      // if(!data['condition']['produceTime']){
      //   data['condition']['produceTime'] = {
      //     begin:moment().format("YYYY-MM-DD HH:mm:ss").substring(0,8) + '01' + " 00:00:00",
      //     end:moment().format("YYYY-MM-DD HH:mm:ss").substring(0,10) + " 23:59:59",
      //     type:"between" ,
      //     data:'date'
      //   }
      // }

      data.condition.factoryId=this.userData.factoryId;
      this.setList = [];
      this.listData = [];
      var list = [];
      productCountReport(data).then(res => {
        if(res.code == 200){
          // this.listData = [];
          // this.setList = [];
          for(var key in res.data){
            if(res.data[key]['dayProduction']){

              for(var key1 in res.data[key]['dayProduction']){
                if(this.setList.indexOf(key1) > -1){
                  res.data[key][key1] = res.data[key]['dayProduction'][key1];
                }else{

                  this.setList.push(key1);
                  res.data[key][key1] = res.data[key]['dayProduction'][key1];
                }
              }
            }
            this.listData.push(res.data[key]);
          }
          this.setList.sort();
          this.loading = false;
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
    },



     // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.search();
    },

    exportExcelNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){
        //this.exportExcel();
        this.$message.error('请选择要导出的数据！')
        return;
      }
      const header = [
        '产品编号',
        '产品名称',
        '产品规格',
        '单位',
        '合计',
      ];

      const filterVal = [
        'productCode',
        'productName',
        'specs',
        'unit',
        'totalNum',
      ];
      for(let i = 0;i<this.setList.length;i++){
        header.push(this.setList[i]);
        filterVal.push(this.setList[i]);
      }
      let filterData =JSON.parse(JSON.stringify(this.tblSelectionList));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"产量统计");
    },
    exportExcel(){
      //this.loading = true
      var data = {
        condition: this.form,
        type:"产量统计",
        currentPage: 1,
        pageSize: 10000,
      }
      data.condition.factoryId=this.userData.factoryId;
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/report/export';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "产量统计" +  ".xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(data));
    },
    productSave(options){
        if(options.type == 'save'){
          this.search()
        }
        this.createProductPanVisible =false;

    },
    viewImportLog(){
      this.isMain = !this.isMain;
    },
    goBack(){
      this.isMain = !this.isMain;
    },
    productFormat(val){
      var res = this.sourceList.filter(function(item){
        return item.value == val.source
      })
      if(res && res.length!=0){
        return res[0].label
      }
    },
  }
};
</script>
<style scoped>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
.user-search {
  margin-top: 20px;
}
.normal-half-width{
  width: calc(100% - 132px);
  margin-left: 8px;
}
.el-divider__text{
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.half-width {
  width: calc(100%);
}
</style>



// WEBPACK FOOTER //
// src/views/home/report/FinishedProduction.vue